<div>
  <div class="grid-x grid-margin-x headline-wrapper">
    <div class="cell small-12 large-offset-1 large-10 text-center">
      <h1 [innerHTML]="'stancheck.gebaeude.ergebnis.headline' | translate"></h1>
    </div>
  </div>

  <div class="grid-x grid-margin-x">
    <div class="cell small-12 large-offset-2 medium-offset-1 medium-10 large-8">
      <div class="callout light-gray">
        <p [innerHTML]="('stancheck.gebaeude.ergebnis.footer') | translate"></p>
      </div>

      <div class="button-wrapper background">
        <app-step-buttons [previousLink]="previousStep? previousStep.path : null" nextText="stancheck.gebaeude.ergebnis.submit"
                          [nextLink]="'../../../ausstattung-haushalt'" [nextSubmit]="false" largeOffset="0"
                          mediumWidthRight="auto" largeWidthRight="auto"></app-step-buttons>
      </div>
    </div>
  </div>

</div>
